import React, { FC } from 'react'

interface Props {
  size?: number
}

export const TwitterIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="16" fill="black" />
    <rect
      x="0.214286"
      y="0.214286"
      width="31.5714"
      height="31.5714"
      rx="15.7857"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="0.428571"
    />
    <path
      d="M20.017 9.71436H22.2451L17.3767 14.991L23.1039 22.1714H18.6193L15.107 17.8163L11.0887 22.1708H8.85798L14.0659 16.5268L8.57129 9.71436H13.1695L16.3442 13.6943L20.017 9.71436ZM19.2343 20.9064H20.4695L12.4984 10.912H11.1739L19.2343 20.9064Z"
      fill="white"
    />
  </svg>
)
